import { defineComponent, createElementBlock, renderSlot, openBlock, normalizeClass } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormWrapperItemLayout",
  props: {
    class: {},
    isHorizontalLayout: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => props.isHorizontalLayout ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(props.class)
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2)) : renderSlot(_ctx.$slots, "default", { key: 1 });
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormWrapperItemLayout.js.map
